import { render, staticRenderFns } from "./NFTViewDashboard.vue?vue&type=template&id=1964754a&scoped=true&"
import script from "./NFTViewDashboard.vue?vue&type=script&lang=ts&"
export * from "./NFTViewDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./NFTViewDashboard.vue?vue&type=style&index=0&id=1964754a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1964754a",
  null
  
)

export default component.exports